// extracted by mini-css-extract-plugin
export default {"wrap":"GestionSectionTeaser_wrap__oIrZy","badge":"GestionSectionTeaser_badge__KuWH+","emptyState":"GestionSectionTeaser_emptyState__PUc19"};